import { useState } from 'react';
import repo from 'service/repository';
import { useAppContext } from "use-app";

const STATES = {
  idled: {
    mutate: 'loading',
  },
  loading: {
    success: 'success',
    error: 'error',
  },
  success: {
    reset: 'idled',
    mutate: 'loading'
  },
  error: {
    reset: 'idled',
    mutate: 'loading'
  }

};

const parseError = (err) => {
  let errorMessage = '優惠序號兌換異常，請稍後再試';

  switch (err.code) {
    case 'redemption_code_not_found':
      errorMessage = '此優惠序號不存在，請確認後再試。';
      break;
    case 'redemption_code_redeemed':
      errorMessage = '此優惠序號已被兌換。';
      break;
    case 'redemption_rule_violated':
      if (err.details === 'reached_redemption_campaign_use_limit') {
        errorMessage = '很抱歉，此優惠序號已全數兌換完畢。';
        break;
      }
      errorMessage = '很抱歉，您不符合本優惠序號兌換條件。';
      break;
    case 'redemption_lock_wait_timeout':
      errorMessage = '兌換失敗。很抱歉，目前兌換需求過多，請稍後再試。';
      break;
    case 'redemption_execute_timeout':
      errorMessage = '兌換失敗。很抱歉，目前兌換需求過多，請稍後再試。';
      break;
    case 'duplicate_global_redemption_code':
    case 'redeem_user_or_plate_number_not_found':
    case 'redemption_campaign_for_user_without_user':
    case 'redemption_code_for_non_user_with_user':
    case 'rewards_distribution_error':
    default:
      errorMessage = '優惠序號兌換異常，請稍後再試';
      break;
  }

  return errorMessage
};

export const useRedeemCoupon = () => {
  const [status, setStatus] = useState('idled');
  const [result, setResult] = useState(undefined)
  const appContext = useAppContext()

  const redeemCoupon = async (code) => {
    if (status === 'loading') return 

    setStatus((s) => {
      return STATES[s]['mutate']
    })

    try {
      const result = await repo.redeemCoupon({ code })
      setResult(result.data.data);
      setStatus(s => {
        return STATES[s]['success'];
      });
    } catch(err) {
      const message = parseError(err.response.data.error)

      appContext.showFailMessage(message);
      setStatus((s) => { 
        return STATES[s]['error']
      })
    }
  }

  return {
    isLoading: status === 'loading',
    isError: status === 'error',
    redeemCoupon,
    result,
  };
};
